import { render } from "./EditQuantityArticleCerere.vue?vue&type=template&id=e4ca6dda&scoped=true&ts=true"
import script from "./EditQuantityArticleCerere.ts?vue&type=script&lang=ts"
export * from "./EditQuantityArticleCerere.ts?vue&type=script&lang=ts"

import "./EditQuantityArticleCerere.vue?vue&type=style&index=0&id=e4ca6dda&scoped=true&lang=scss"

import exportComponent from "D:\\Melinda\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ca6dda"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QToggle,QCircularProgress,QBtn});qInstall(script, 'directives', {ClosePopup});
